import React from 'react'
// libs
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// components
import UsersPermissions from './components/UserPermissions'
import { ReduxEntitySelect, ReduxSelect, ReduxSwitch } from 'components/FormElements'
// graphql
import { RISK_TEMPLATE_SELECT_QUERY } from 'graphql/risk/queries'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// constants
import { FORM_MULTIPLE_OPTIONS, FORM_POSITION_OPTIONS } from 'constants/systemProcesses'
// views
import { Link, FormFieldWrapper, RelatedFormsContainer, SwitchWrapper } from './views'
// types
import { Forms } from 'constants/forms'
import { IOption } from 'components/FormElements/Select'
// utils
import { required } from 'utils/validators'
import { riskTemplatesProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

interface Props {
  field: string
  form: Record<string, any>
}

const RelatedForm: React.FC<Props> = ({ field, form }) => {
  const dispatch = useDispatch()

  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const prepareOptions = (options: IOption[]) => options.filter((option) => option.value !== riskTemplate?.id)

  const onFormSelect = () => {
    dispatch(change(Forms.SYSTEM_PROCESS_CREATE_FORM, `${field}.multiple`, FORM_MULTIPLE_OPTIONS[1]))
    dispatch(change(Forms.SYSTEM_PROCESS_CREATE_FORM, `${field}.position`, FORM_POSITION_OPTIONS[0]))
    dispatch(change(Forms.SYSTEM_PROCESS_CREATE_FORM, `${field}.inheritToManagers`, false))
  }

  return (
    <RelatedFormsContainer>
      <FormFieldWrapper>
        <ReduxEntitySelect
          label='Form'
          validate={required}
          menuPortalTarget={null}
          onSelectChange={onFormSelect}
          prepareOptions={prepareOptions}
          name={`${field}.riskTemplate`}
          query={RISK_TEMPLATE_SELECT_QUERY}
          {...riskTemplatesProps}
        />
        {form && (
          <Link target='_blank' href={`/forms/templates/${form}`}>
            Edit template
          </Link>
        )}
      </FormFieldWrapper>
      <ReduxSelect
        label='Multiple'
        validate={required}
        menuPortalTarget={null}
        name={`${field}.multiple`}
        options={FORM_MULTIPLE_OPTIONS as unknown as IOption[]}
      />
      <ReduxSelect
        label='Position'
        validate={required}
        menuPortalTarget={null}
        name={`${field}.position`}
        options={FORM_POSITION_OPTIONS as unknown as IOption[]}
      />
      <SwitchWrapper>
        <ReduxSwitch label='Enable Supervisor Hierarchy' name={`${field}.inheritToManagers`} justifyContent='flex-start' />
      </SwitchWrapper>
      <UsersPermissions field={field} />
    </RelatedFormsContainer>
  )
}

export default RelatedForm
